import React, { useContext } from 'react';

import { BiQuestionMark } from 'react-icons/bi'

export default function Confirm(props) {
    const { alert } = props;

    return (
        <>
            <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4'>
                <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-md w-full mx-4 overflow-hidden'>
                    <div className="p-8 text-center">
                        <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-6">
                            <BiQuestionMark className="w-8 h-8 text-blue-600 dark:text-blue-400" />
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4"> {alert.title} </h1>
                        <span className='text-gray-600 dark:text-gray-400 block'> {alert.placeholder} </span>
                    </div>
                    <div className="flex gap-4 p-6 bg-gray-50 dark:bg-gray-700" >
                        <button 
                            className="flex-1 px-6 py-3 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-xl font-semibold hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors duration-200" 
                            onClick={props.quitAlert}
                        >
                            Voltar
                        </button>
                        <button 
                            className="flex-1 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white rounded-xl font-semibold transition-colors duration-200 shadow-vox hover:shadow-vox-lg" 
                            onClick={props.quitAlertConfirm}
                        >
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}